import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { ValidationSchema } from '../_shared/validation'
import PlacaFormGroup from '../_shared/formGroups/placa'

const EditarPlacaModal = ({ handleClose, show, actualizarPlaca, modalData }) => {
  const formInitialValues = React.useMemo(
    () => ({
      placa: modalData.placa || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarPlaca({
      ...modalData,
      ...data
    })
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>EDITAR PLACA</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        onSubmit={submitHandler}
        validationSchema={ValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <PlacaFormGroup
                iError={errors.placa}
                iTouched={touched.placa}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarPlacaModal
